import { type FC, useState } from 'react';
import { PiLinkSimpleBold } from 'react-icons/pi';

interface ThirdPartyLinkButtonProps {
  url?: string;
}

function extractNameAndDomain(
  url?: string
): { name: string; domain: string } | null {
  if (!url) return null;
  try {
    const { hostname } = new URL(url);
    const cleanHost = hostname.replace(/^www\./, '');
    const parts = cleanHost.split('.');
    const name = parts[0];
    // Domain: last two parts (e.g., 'google.com')
    const domain = parts.slice(-2).join('.');
    return { name, domain };
  } catch {
    return null;
  }
}

const ThirdPartyLinkButton: FC<ThirdPartyLinkButtonProps> = ({ url }) => {
  const info = extractNameAndDomain(url);
  const [showFullUrl, setShowFullUrl] = useState(false);

  return (
    <>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-primary-lighter px-2 py-1 rounded-full text-primary flex items-center gap-1 cursor-pointer hover:bg-gray-5 transition-all duration-200"
        style={{
          minWidth: 0,
          width: 'fit-content',
          maxWidth: '100%',
          textDecoration: 'none',
        }}
        onMouseEnter={() => {
          setShowFullUrl(true);
        }}
        onMouseLeave={() => {
          setShowFullUrl(false);
        }}
      >
        <PiLinkSimpleBold className="inline-block" />
        <span
          className="whitespace-nowrap overflow-hidden inline-block transition-all duration-200"
          style={{
            maxWidth: showFullUrl ? 400 : 120,
            width: 'auto',
            transition: 'max-width 0.2s cubic-bezier(0.4,0,0.2,1)',
            textOverflow: 'ellipsis',
            verticalAlign: 'bottom',
          }}
          title={showFullUrl ? url : info?.domain ?? ''}
        >
          {showFullUrl ? url : info?.domain}
        </span>
      </a>
    </>
  );
};
export default ThirdPartyLinkButton;
